export default "__VITE_ASSET__DlHNCCod__"